import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../dailyWetAction';
import fetchApi from "./fetchApi";

function fetchDailyWetAction() {
  return fetchApi('/v1/fc_api/daily_wet_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchDailyWetAction;
